import { reactive } from "vue";

export const plugins = reactive({
  list: [],
  objList: {},
});